import BaseApi from "./base-api";
import { DefaultArachnaRequestInterceptor } from "../interceptors";
// import DefaultArachnaResponseInterceptor from "../../interceptors/default-arachna-response.interceptor";
export default class ArachnaApi extends BaseApi {
    defaultRequestInterceptors() {
        return [
            DefaultArachnaRequestInterceptor
        ];
    }
    defaultResponseInterceptors() {
        return [];
    }
}
